import { motion } from "framer-motion";
import { IMAGES } from "@/data/spa";
import { useLang } from "@/i18n/LanguageContext";
import { TiltCard } from "@/components/spa/TiltCard";

const images = [IMAGES.therapist, IMAGES.headMassage, IMAGES.footMassage];
const chars = ["身", "首", "足"];

export const Therapists = () => {
  const { t } = useLang();
  return (
    <section id="team" data-testid="therapists-section" className="relative py-24 lg:py-40 overflow-hidden">
      <span aria-hidden="true" className="ghost-char top-8 right-2">手</span>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[#c5a059]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#c5a059]">{t.team.label}</span>
          </div>
          <h2 className="font-serif-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-[#f0f4f2]">
            {t.team.title.pre}<span className="italic text-[#c5a059]">{t.team.title.it}</span>{t.team.title.post}
          </h2>
          <p className="mt-6 text-[#8a9690] font-light leading-relaxed max-w-lg">{t.team.intro}</p>
        </motion.div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {t.team.cards.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.14, ease: [0.22, 1, 0.36, 1] }}
            >
              <TiltCard
                testid={`practice-card-${i + 1}`}
                max={5}
                lift={8}
                glow="0 28px 65px -20px rgba(197,160,89,0.5)"
                className="group h-full"
              >
                <div className="relative overflow-hidden h-[360px]">
                  <img
                    src={images[i]}
                    alt={c.specialty}
                    className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050706] via-transparent to-transparent" />
                  <span aria-hidden="true" className="absolute top-4 right-5 font-serif-display text-5xl text-[#c5a059]/30 select-none">{chars[i]}</span>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="text-[10px] tracking-[0.3em] uppercase text-[#c5a059]">{c.specialty}</span>
                    <h3 className="mt-2 font-serif-display text-2xl lg:text-3xl text-[#f0f4f2]">{c.title}</h3>
                  </div>
                </div>
                <div className="border border-t-0 border-white/10 p-6 group-hover:border-[#c5a059]/30 transition-colors duration-500 bg-[#0c100e]">
                  <p className="text-sm text-[#8a9690] font-light leading-relaxed">{c.text}</p>
                </div>
              </TiltCard>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
